// 404

import { useState, useEffect } from 'react'
import { message, Form, Input, Button, Modal, Carousel } from 'antd'
import fun from '../../common/common_fun'
import url from '../../common/url_config'
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import cookie from 'react-cookies'

function App() {
  let [current_language_ch, set_current_language_ch] = useState(window.location.href.indexOf('?lan=en') === -1)//当前语言是否中文
  let [current_height, set_current_height] = useState(document.documentElement.clientHeight)//当前页面高度

  useEffect(() => {
    window.addEventListener('resize', (e: any) => {
      set_current_height(document.body.clientHeight)
    })
  }, [])

  return (
    <div style={{ minHeight: '100%', backgroundColor: '#f5f5f5' }} className='main_index_show'>
      <div>
        <h2 style={{ textAlign: 'center', paddingTop: 50, paddingBottom: 20, fontSize: 40 }}>{current_language_ch ? '找不到页面' : 'Page Not Found'}</h2>
        {current_language_ch ? <div style={{ textAlign: 'center' }}>如果您使用书签访问本页面，请删除该书签，然后尝试从<a style={{ color: '#215bd6' }} href='/'>主页</a>导航到本页面。</div> :
          <div style={{ textAlign: 'center' }}>If you used a bookmark, please delete it and navigate from the <a style={{ color: '#215bd6' }} href='/?lan=en'>homepage</a>.</div>}
      </div>
      <div style={{ height: current_height - 370 }}></div>
    </div>
  )
}

export default App